// extracted by mini-css-extract-plugin
export default {"adcu-security-detail":"adcu-security-detail_adcu-security-detail__tHqz-"};